<template>
  <div class="LanguageBox">
    <BaseCheckType1
      v-for="(item, index) in propLanguages"
      :key="index"
      :prop-label="item"
      v-model="tempValue[item]"
      @click="selected(item)"
    />
  </div>
</template>

<script>
import BaseCheckType1 from '@/components/common/form-elemnets/BaseCheckType1'

export default {
  name: 'LanguageBox',
  components: { BaseCheckType1 },
  props: {
    propLanguages: {
      default: () => [
        'English',
        'German',
        'French',
        '한국어',
        '日本語',
        '中國語'
      ],
      type: Array
    },
    value: {
      default: () => ['English', '한국어'],
      type: Array
    }
  },
  data() {
    return {
      tempValue: this.value.reduce(
        (a, c) => Object.assign(a, { [c]: true }),
        {}
      )
    }
  },
  watch: {
    value(newValue) {
      console.log('tempValue new value:', newValue)
      if (newValue) {
        this.tempValue = this.value.reduce(
          (a, c) => Object.assign(a, { [c]: true }),
          {}
        )
      }
    }
  },
  methods: {
    selected(item) {
      let entries = []
      if (this.tempValue[item]) {
        this.$delete(this.tempValue, item)
        entries = Object.entries(this.tempValue)
          .flat(2)
          .filter(e => typeof e === 'string')
        this.$emit('input', entries)
        console.log('result:', entries)
      } else {
        this.tempValue = Object.assign({}, this.tempValue, { [item]: true })
        entries = Object.entries(this.tempValue)
          .flat(2)
          .filter(e => typeof e === 'string')
        this.$emit('input', entries)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.LanguageBox {
  width: 440px;
  height: 102px;
  border: solid 1px #e7e7e7;
  background-color: #ffffff;
  display: grid;
  grid-template-columns: repeat(auto-fit, 100px);
  justify-content: space-around;
  grid-column-gap: 20px;
}
</style>
